import { render, staticRenderFns } from "./PasswordConfirmationSuccess.vue?vue&type=template&id=84c68da0&"
import script from "./PasswordConfirmationSuccess.vue?vue&type=script&lang=ts&"
export * from "./PasswordConfirmationSuccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports